module.exports = __webpack_public_path__ + "static/responsive-6d5828502f5363748ec18beb5f35a4a5.gif";